import { Controller } from "@hotwired/stimulus"

// Keeps the visual pill selection in sync with the hidden radio input.
// Sets data-state="selected" on the active pill label and
// data-state="unselected" on all others.
export default class extends Controller {
  static targets = ["pill"]

  connect() {
    this._syncPills()
  }

  select(event) {
    this._syncPills(event.currentTarget)
  }

  _syncPills(changedRadio = null) {
    const active = changedRadio || this.element.querySelector("input[type='radio']:checked")
    this.pillTargets.forEach(label => {
      const radio = label.querySelector("input[type='radio']")
      label.dataset.state = (radio === active || radio?.checked) ? "selected" : "unselected"
    })
  }
}
